import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './ButtonWithLoader.module.scss';
import SvgIcon from 'components/SvgIcon/SvgIcon';

const ButtonWithLoader = ({
  bsStyle = 'primary',
  bsSize,
  disabled = false,
  href = '',
  loading = false,
  onClick = null,
  style = null,
  className = '',
  text = '',
  success = false,
  id = '',
  icon = null,
  iconAfter = false,
  type = 'button',
  'aria-label': ariaLabel,
}) => {
  return (
    <>
      <Button
        bsStyle={success ? 'success' : bsStyle}
        {...(bsSize && { bsSize })}
        disabled={disabled}
        href={href}
        onClick={onClick}
        style={style}
        className={className + ' ' + styles.button}
        id={id}
        type={type}
        aria-label={ariaLabel}
        aria-busy={loading || undefined}
      >
        {success ? (
          <SvgIcon
            icon="tick_outline"
            width={className.includes('btn-lg') ? '27px' : '16px'}
            height={className.includes('btn-lg') ? '27px' : '16px'}
            color="white"
          />
        ) : (
          <>
            {loading ? (
              <div>
                <div
                  className={`${styles.button__loading} ${
                    bsStyle === 'hollow' ? styles.button__loadingHollow : ''
                  }`}
                  role="status"
                  aria-label="Loading"
                />{' '}
                {text}
              </div>
            ) : (
              <>
                {iconAfter ? null : icon}
                {text}
                {iconAfter ? icon : null}
              </>
            )}
          </>
        )}
      </Button>
    </>
  );
};

ButtonWithLoader.propTypes = {
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  success: PropTypes.bool,
  id: PropTypes.string,
  icon: PropTypes.node,
  iconAfter: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  'aria-label': PropTypes.string,
};

export default ButtonWithLoader;
